/**
 * navigator.clipboard.writeText の共通ラッパー。
 * 成功可否を boolean で返し、失敗時のログ出力を一元化する。
 *
 * @param {string} text - クリップボードに書き込む文字列。
 * @returns {Promise<boolean>} 成功時 true、失敗時 false。
 */
export async function writeClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (clipboardError) {
    console.error('クリップボードへのコピーが失敗しました。', clipboardError);
    return false;
  }
}
